import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import ArtTrackIcon from '@mui/icons-material/ArtTrack'
import GTranslateIcon from '@mui/icons-material/GTranslate';
import AddTaskIcon from '@mui/icons-material/AddTask';
import LightModeIcon from '@mui/icons-material/LightMode';

const data = [
  {
    title: 'Speak anywhere',
    description: 'Dictate into Gmail, Docs, Slack, support tools, forms, and any browser text field.',
    icon: <ArtTrackIcon />,
  },
  {
    title: '100+ languages',
    description: 'Move between languages naturally with quick language controls and translation support.',
    icon: <GTranslateIcon />,
  },
  {
    title: 'Voice commands',
    description: 'Use custom commands, snippets, and shortcuts for repeated phrases or formatting.',
    icon: <AddTaskIcon />,
  },
  {
    title: 'Polished output',
    description: 'Clean up filler words, add punctuation, and turn rough speech into usable writing.',
    icon: <LightModeIcon />,
  },
]

const HomeFeature = () => {
  return (
    <Box id="feature" sx={{ py: { xs: 10, md: 14 }, backgroundColor: 'background.default' }}>
      <Container>
        <Grid container spacing={5} alignItems="center">
          <Grid item xs={12} md={5}>
            <Box sx={{ position: 'relative', p: 2, borderRadius: 3, bgcolor: 'common.white', boxShadow: 10 }}>
              <Box component="img" src="/images/home-feature.png" sx={{ width: '100%', display: 'block' }} alt="Feature img" />
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
            <Typography
              component="h2"
              sx={{
                position: 'relative',
                fontSize: { xs: 34, md: 48 },
                ml: { xs: 0, md: 4 },
                mb: 3,
                lineHeight: 1.12,
                fontWeight: 800,
              }}
            >
                Built for {' '}
              <Typography
                component="mark"
                sx={{
                  position: 'relative',
                  color: 'primary.main',
                  fontSize: 'inherit',
                  fontWeight: 'inherit',
                  backgroundColor: 'unset',
                }}
              >
                fast voice input <br />
              </Typography>
            </Typography>
            <Typography sx={{ color: 'text.secondary', mb: 3, ml: { xs: 0, md: 4 }, fontSize: 16, lineHeight: 1.8 }}>
              A focused voice interface inspired by modern dictation tools: start fast, see status clearly, and trust the output before it lands.
            </Typography>

            <Grid container spacing={2} sx={{ ml: { xs: 0, md: 2 } }}>
              {data.map(({ title, description, icon }, index) => (
                <Grid key={String(index)} item xs={12} md={6}>
                  <Box sx={{ p: 2.5, height: '100%', boxShadow: 4, borderRadius: 2, bgcolor: 'common.white', border: (theme) => `1px solid ${theme.palette.divider}`, display: 'flex', alignItems: 'flex-start' }}>
                    <Box
                      sx={{
                        mr: 1.5,
                        backgroundColor: 'primary.lighter',
                        borderRadius: 1.5,
                        height: 42,
                        width: 42,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'primary.dark',
                        '& svg': {
                          fontSize: 20,
                        },
                      }}
                    >
                      {icon}
                    </Box>
                    <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                      <Typography variant="h6" sx={{ fontSize: '1rem', mb: 1, color: 'text.primary' }}>
                        {title}
                      </Typography>
                      <Typography sx={{ lineHeight: 1.6, color: 'text.secondary' }} variant="body2">
                        {description}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default HomeFeature
